import styled from 'styled-components'

export const Section = styled.section`
  background-color: ${props => props.bgColor};
  padding: 34px 20px 0 20px;
  border-bottom: 1px solid #E0E0E0;

  @media (max-width: 767px) {
    padding: 20px 16px 0 16px;
  }
`

export const Container = styled.div`
  max-width: ${props => props.maxWidth};
  width: 100%;
  margin: 0 auto;
`

export const Title = styled.h1`
  margin-top: 0;
  margin-bottom: 27px;
  color: rgba(0, 0, 0, 0.87);
  font-size: 2.125rem;
  font-weight: 400;
  line-height: 40px;
  letter-spacing: 0.25px;

  @media (max-width: 767px) {
    font-size: 1.5rem;
    line-height: 30px;
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    font-size: 1.8rem;
  }
`
